export default __webpack_public_path__ + "static/media/logo-custom_oauth2.082fe0a9.svg";